import { Buffer } from 'buffer';
import process from 'process';

if (typeof window !== 'undefined') {
    window.global = window;
    window.process = process;
    window.Buffer = Buffer;

    // Safe navigator.permissions check
    if (navigator.permissions && !navigator.permissions.query) {
        try {
            navigator.permissions.query = (parameters) => Promise.resolve({ state: 'granted' });
        } catch (e) {
            console.warn('Could not polyfill navigator.permissions.query', e);
        }
    }
}
